<div class="px-6 py-5 max-w-2xl mx-auto">
  <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-6">
    <div class="flex items-center gap-3 mb-6">
      <div class="w-10 h-10 rounded-lg bg-vivid-royal-100 dark:bg-vivid-royal-800 flex items-center justify-center">
        <i class="pi pi-lock text-vivid-royal-500 dark:text-vivid-royal-300"></i>
      </div>
      <h2 class="text-lg font-bold text-vivid-royal-700 dark:text-vivid-royal-100">Cambiar contraseña</h2>
    </div>

    <form [formGroup]="formPassword" class="space-y-5">
      <!-- Current password -->
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Contraseña actual</label>
        <div class="relative mt-1">
          <input [type]="passwordType0" maxlength="64" formControlName="oldPassword"
            class="w-full pr-10 px-4 py-2 rounded-lg border border-dark-khaki-200 dark:border-vivid-royal-700 bg-white dark:bg-vivid-royal-900 text-vivid-royal-800 dark:text-white outline-none focus:border-vivid-royal-500" />
          <button type="button" class="absolute top-1/2 -translate-y-1/2 right-3 text-vivid-royal-400 hover:text-vivid-royal-600 cursor-pointer"
            (click)="togglePasswordVisibility0()">
            <i [class]="showPassword0 ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
          </button>
        </div>
      </div>

      <!-- New password -->
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Nueva contraseña</label>
        <div class="relative mt-1">
          <input [type]="passwordType1" maxlength="64" formControlName="password"
            class="w-full pr-10 px-4 py-2 rounded-lg border border-dark-khaki-200 dark:border-vivid-royal-700 bg-white dark:bg-vivid-royal-900 text-vivid-royal-800 dark:text-white outline-none focus:border-vivid-royal-500" />
          <button type="button" class="absolute top-1/2 -translate-y-1/2 right-3 text-vivid-royal-400 hover:text-vivid-royal-600 cursor-pointer"
            (click)="togglePasswordVisibility1()">
            <i [class]="showPassword1 ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
          </button>
        </div>
      </div>

      <!-- Confirm password -->
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Confirmar contraseña</label>
        <div class="relative mt-1">
          <input [type]="passwordType2" maxlength="64" formControlName="newPassword"
            class="w-full pr-10 px-4 py-2 rounded-lg border border-dark-khaki-200 dark:border-vivid-royal-700 bg-white dark:bg-vivid-royal-900 text-vivid-royal-800 dark:text-white outline-none focus:border-vivid-royal-500" />
          <button type="button" class="absolute top-1/2 -translate-y-1/2 right-3 text-vivid-royal-400 hover:text-vivid-royal-600 cursor-pointer"
            (click)="togglePasswordVisibility2()">
            <i [class]="showPassword2 ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
          </button>
        </div>
      </div>

      <!-- Validation rules -->
      <div class="bg-dark-khaki-50 dark:bg-vivid-royal-900 rounded-lg p-4 space-y-2">
        <p class="text-xs font-semibold text-vivid-royal-500 dark:text-vivid-royal-200 mb-2">Requisitos de contraseña</p>
        <div class="flex items-center gap-2 text-sm"
          [ngClass]="password!.value?.length >= 12 ? 'text-green-600' : 'text-vivid-royal-400'">
          <i [class]="password!.value?.length >= 12 ? 'pi pi-check-circle text-green-500' : 'pi pi-circle text-gray-300'"></i>
          12+ caracteres
        </div>
        <div class="flex items-center gap-2 text-sm"
          [ngClass]="password!.value?.match('(?=.*[A-Z])') ? 'text-green-600' : 'text-vivid-royal-400'">
          <i [class]="password!.value?.match('(?=.*[A-Z])') ? 'pi pi-check-circle text-green-500' : 'pi pi-circle text-gray-300'"></i>
          Mayúscula
        </div>
        <div class="flex items-center gap-2 text-sm"
          [ngClass]="password!.value?.match('(?=.*[a-z])') ? 'text-green-600' : 'text-vivid-royal-400'">
          <i [class]="password!.value?.match('(?=.*[a-z])') ? 'pi pi-check-circle text-green-500' : 'pi pi-circle text-gray-300'"></i>
          Minúscula
        </div>
        <div class="flex items-center gap-2 text-sm"
          [ngClass]="password!.value?.match('(?=.*[0-9])') ? 'text-green-600' : 'text-vivid-royal-400'">
          <i [class]="password!.value?.match('(?=.*[0-9])') ? 'pi pi-check-circle text-green-500' : 'pi pi-circle text-gray-300'"></i>
          Número
        </div>
        <div class="flex items-center gap-2 text-sm"
          [ngClass]="password!.value?.match('(?=.*[!@#$%^&*()_+\\-=\\[\\]{}|;:,.<>?/])') ? 'text-green-600' : 'text-vivid-royal-400'">
          <i [class]="password!.value?.match('(?=.*[!@#$%^&*()_+\\-=\\[\\]{}|;:,.<>?/])') ? 'pi pi-check-circle text-green-500' : 'pi pi-circle text-gray-300'"></i>
          {{'Carácter especial (!@#$%^&*)'}}
        </div>
        @if(password!.value && newPassword!.value && password!.value !== newPassword!.value) {
          <div class="flex items-center gap-2 text-sm text-red-500">
            <i class="pi pi-times-circle"></i> Las contraseñas no coinciden
          </div>
        }
        @if(oldPassword!.value && password!.value && oldPassword!.value === password!.value) {
          <div class="flex items-center gap-2 text-sm text-red-500">
            <i class="pi pi-times-circle"></i> La nueva contraseña no puede ser igual a la actual
          </div>
        }
        @if(msgError) {
          <div class="flex items-center gap-2 text-sm text-red-500">
            <i class="pi pi-times-circle"></i> {{ msgError }}
          </div>
        }
      </div>

      <button pButton [label]="inProcess ? 'Guardando...' : 'Guardar contraseña'"
        [icon]="inProcess ? 'pi pi-spin pi-spinner' : 'pi pi-check'" class="p-button-sm w-full"
        [disabled]="inProcess || formPassword.invalid || password!.value !== newPassword!.value || oldPassword!.value === password!.value"
        (click)="confirmAction()"></button>
    </form>
  </div>
</div>
